// webkitAudioContext fallback needed for Safari
export const audioContext = new ((window as any).AudioContext ||
  (window as any).webkitAudioContext)();
export const SOUNDFONT_HOSTNAME = process.env.REACT_APP_SOUNDFONT_HOSTNAME as string;

if (!SOUNDFONT_HOSTNAME) {
  throw new Error('process.env.REACT_APP_SOUNDFONT_HOSTNAME not defined');
}
